import React from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Box,
  BoxList,
  Button,
  Icon,
  List,
  Text,
  useBreakpoint,
} from '@factorialco/deprecated-design-system'
import { PerformanceProcessAgreementListCardFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { AgreementStatusTag } from 'modules/performance_process/components/agreements/StatusTag'

export const AgreementTask: React.FC<{
  target: PerformanceProcessAgreementListCardFragment
  onInitiate?: () => Promise<unknown> | void
  isCheckingOwnAgreement?: boolean
}> = ({ target, onInitiate = () => null, isCheckingOwnAgreement = false }) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { isMobile } = useBreakpoint()

  const process = target?.performanceReviewProcess
  const agreementPath = (agreementId: string) =>
    isCheckingOwnAgreement
      ? navigation.performanceProcess.reviews.review.myResultsAgreement.fullPath({
          targetId: target.id,
          reviewId: process?.id ?? '',
          agreementId,
        })
      : navigation.performanceProcess.reviews.review.target.agreement.fullPath({
          targetId: target.id,
          reviewId: process?.id ?? '',
          agreementId,
        })

  const agreement = target?.agreement || null

  let signatureCount = 0
  if (agreement?.managerSignedAt) signatureCount += 1
  if (agreement?.targetSignedAt) signatureCount += 1

  const hasAgreementCreated = agreement !== null
  const canInitiateAgreement = !hasAgreementCreated && target._policies?.initiate?.can

  return (
    <BoxList>
      <List.ClickableItem
        navigateTo={
          canInitiateAgreement
            ? async () => await onInitiate()
            : hasAgreementCreated
            ? () => navigate(agreementPath(agreement?.id))
            : undefined
        }
      >
        <Box flexDirection="row" gap="s16" alignItems="center">
          <Icon.Large icon="document-handshake" color="radicalRed1000" />
          <Text.Normal size="300" weight="medium" color="grey1000">
            {i18n.t('performance_process.reviews.peer_management.peers_datatable.agreement')}
          </Text.Normal>
          {agreement && (
            <Text.Normal>
              {i18n.t('performance_process.agreements.agreement_list_card.count', {
                count: signatureCount,
                total: 2,
              })}
            </Text.Normal>
          )}
        </Box>
        <Box flexDirection="row" gap="s16" alignItems="center">
          {agreement && <AgreementStatusTag status={agreement.status} />}
          {canInitiateAgreement && (
            <Button type="secondary" onClick={async () => await onInitiate()}>
              {i18n.t('performance_process.agreements.agreement_list_card.initiate')}
            </Button>
          )}
          {!isMobile && hasAgreementCreated && (
            <Button.Router
              type="secondary"
              to={agreementPath(agreement?.id)}
              iconName="arrow-right"
            />
          )}
        </Box>
      </List.ClickableItem>
    </BoxList>
  )
}
